import { render, staticRenderFns } from "./EditLeadIbanDialog.vue?vue&type=template&id=4d573840&scoped=true"
import script from "./EditLeadIbanDialog.vue?vue&type=script&lang=ts"
export * from "./EditLeadIbanDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditLeadIbanDialog.vue?vue&type=style&index=0&id=4d573840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d573840",
  null
  
)

export default component.exports